import { render, staticRenderFns } from "./modalRegraCobranca.vue?vue&type=template&id=918c4762&scoped=true"
import script from "./modalRegraCobranca.vue?vue&type=script&lang=js"
export * from "./modalRegraCobranca.vue?vue&type=script&lang=js"
import style0 from "./modalRegraCobranca.vue?vue&type=style&index=0&id=918c4762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918c4762",
  null
  
)

export default component.exports